import { render } from "./TrainingDashboard.vue?vue&type=template&id=6ec46499"
import script from "./TrainingDashboard.vue?vue&type=script&lang=js"
export * from "./TrainingDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__